export default __webpack_public_path__ + "static/media/ORYX_AttractorsIcon.e95da1e2.svg";